import MapGL, { Image, Layer, Source, Viewport } from "@urbica/react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import React, { useEffect, useRef, useState } from "react";
import useGlobalContext from "./Context/useGlobalContext";
import ReplayPlayer from "./ReplayPlayer";
import SideBar from "./SideBar";
import { flightIcon, searchFlightIcon } from "./assets/icons";
import StyleSheet from "./commonComponents/StyleSheet";
import Header from "./components/Header";
import NoiseComplaintForm from "./components/NoiseComplaintForm";
import config from "./config.json";
import { Backdrop } from "@material-ui/core";
import CircularProgress from '@material-ui/core/CircularProgress';
import AddressSearchBar from "./components/AddressSearchBar";
import LocationMarker from "./components/LocationMarker";
import TermsAndConditionDialog from "./components/TermsAndConditionDialog";

const highLightColor = config.highLightColor || "";
const emitterTypeIcons = config.emitterTypeIcons;
const emitterTypeKeys = emitterTypeIcons.iconValues.map((item) => item.type)

const Map = () => {
  const {
    isLive,
    isShowForm,
    setIsLive,
    setFlightFeatureCollection,
    setIsShowForm,
    showSnackBar,
    viewPort,
    setViewPort,
    flightFeatureCollection,
    searchFlightData,
    currentMapStyle,
    setIsLoading,
    loading,
    searchViewPort,
    isShowTermsAlert
  } = useGlobalContext();
  const replayPlayerRef: any = useRef();

 
  const onViewPortChange = (vi: Viewport) => {
    setViewPort({
      longitude: vi.longitude,
      latitude: vi.latitude,
      zoom: vi.zoom,
    });
  };

  useEffect(() => {
    showTargets(Date.now() - 120000);
    // console.log("mmmm", isLive);
  }, []);

  const showTargets = (timeStamp: number) => {
    replayPlayerRef.current?.startPlayer(timeStamp);
  };

  // console.log('fffff', flightFeatureCollection);

  const onClickApply = (timestamp: number) => {
    setIsLive(false);
    showTargets(timestamp);
    setFlightFeatureCollection({
      ...flightFeatureCollection,
      features: [],
    });
  };

  const handleClose = () => {
    setIsLoading(false)
  }

  const onSubmitForm = () => {
    setIsShowForm(false);
    showSnackBar("Successfully Submitted") 
  }
 

  return (
    <div style={styles.container}>
      <SideBar {...{ onClickApply }} />
      <Header />
      <img
        src={config.weatherURL}
        style={{
          position: "absolute",
          top: "65px",
          right: "10px",
          zIndex: 10,
        }}
      />
      
      <MapGL
        {...viewPort}
        style={{
          width: "100vw",
          height: isLive ? "100vh" : "92vh",
        }}
        mapStyle={currentMapStyle.url}
        accessToken={process.env.REACT_APP_MAPBOX_TOKEN}
        latitude={viewPort.latitude}
        longitude={viewPort.longitude}
        zoom={viewPort.zoom}
        onViewportChange={(vi) => onViewPortChange(vi)}
        dragPan
        dragRotate
        doubleClickZoom
        divZoom
        maxTileCacheSize={0}
        cursorStyle="mouse"
      >
          {
          emitterTypeIcons.isEnabled ? emitterTypeIcons.iconValues.map((item) => {
            return <Image key={`${item.path}_${item.type}`} id={`${item.type}`} image={require(`./assets/icons/${item.path}.png`).default} sdf={false} />
          }
          ) : null
        }
           {currentMapStyle.mbtitlesUrl ? (
             [
              <Source key="raster-1" id="raster-1" type="raster" tileSize={256} tiles={[currentMapStyle.mbtitlesUrl]} />,
               <Layer
                 key="raster"
                 before={'id'}
                 id="raster"
                 type="raster"
                 source="raster-1"
                />
             ]
           ) : (
             <div />
           )}
        <Source
          key={`id-1`}
          id={`id-1`}
          type="geojson"
          data={flightFeatureCollection}
        />
        <Image key={`id-2`} id={`my-id-image`} image={flightIcon} sdf={false} />
        <Image
          key={`id-3`}
          id={`search-id-image`}
          image={searchFlightIcon}
          sdf={false}
        />
        <Layer
          id={"id"}
          key={`id-4`}
          type="symbol"
          source={`id-1`}
          layout={{
            "icon-image": [
              "case",
              [
                "all",
                ["==", ["get", "aid"], searchFlightData],
                ["!=", ["get", "aid"], ""],
              ],
              "search-id-image",
              [
                "all",
                ["==", ["get", "tail"], searchFlightData],
                ["!=", ["get", "tail"], ""],
              ],
              "search-id-image",
              ["all", ["==", emitterTypeIcons.isEnabled, true], ["==", ["has", "emittertype"], true], ["==", ["in", ["get", 'emittertype'], ["literal", emitterTypeKeys]], true]],
              ["get", "emittertype"],
              "my-id-image",
            ],
            "icon-ignore-placement": true,
            "icon-allow-overlap": true,
            "icon-size":
              viewPort.zoom > 18
                ? 0.05
                : viewPort.zoom > 15
                ? 0.04
                : viewPort.zoom > 10
                ? 0.04
                : viewPort.zoom > 8
                ? 0.03
                : viewPort.zoom > 6
                ? 0.02
                : viewPort.zoom > 5
                ? 0.02
                : viewPort.zoom > 3
                ? 0.01
                : 0.01,
            "icon-padding": 0,
            "icon-rotate": ["get", `head`],
            "icon-rotation-alignment": "map",
            "text-allow-overlap": true,
            "text-field": config.dataTagsFormat,
            "text-font": [
              "literal",
              ["Source Sans Pro Bold", "Arial Unicode MS Regular"],
              // ['Roboto Black', 'Arial Unicode MS Bold']
            ],
            "text-justify": "left",
            "text-size": 14,
            "text-transform": "uppercase",
            "text-letter-spacing": 0.05,
            "text-offset": ["literal", [0, -1.6]],
            "text-line-height": 0.95,
          }}
          paint={{
            "icon-color": "#00d6ee",
            "icon-halo-blur": 5,
            "icon-halo-color": "#00d6ee",
            "text-color": [
              "case",
              [
                "all",
                ["==", ["get", "aid"], searchFlightData],
                ["!=", ["get", "aid"], ""],
              ],
              highLightColor,
              [
                "all",
                ["==", ["get", "tail"], searchFlightData],
                ["!=", ["get", "tail"], ""],
              ],
              highLightColor,
              config.dataTagColor,
            ], // need to check with source
            "text-halo-color": "rgba(7, 4, 28, 0.3)",
            "text-halo-blur": 10,
            "text-halo-width": 48,
          }}
        />
              <LocationMarker
          latitude={searchViewPort.latitude}
          longitude={searchViewPort.longitude}
        />
      </MapGL>
      <ReplayPlayer ref={replayPlayerRef} />
      {
        isShowTermsAlert ? <TermsAndConditionDialog /> : null
      }
      <NoiseComplaintForm
        show={isShowForm}
        onHide={() => setIsShowForm(false)}
        onSubmitted={onSubmitForm}
        onError={(message) => showSnackBar(message)}
      />
         <Backdrop style={styles.backdrop} open={loading} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

const styles = StyleSheet.create({
  container: {
    display: "flex",
    flexDirection: "column",
    // backgroundColor: "darkgreen",
    width: "100vw",
    height: "100vh",
  },
  backdrop: {
    zIndex:100000,
    color: '#fff',
  },
});

export default Map;
